import { Nullable } from '@/utils/types';

export const parseJwt = (token: string): Nullable<Record<string, any>> => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};
